<div class="card">

    <div class="card-body mt-5">
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-12 px-0 d-flex align-items-center mb-3">
                        <label class="form-label mb-0">Online appointments schedule</label>&nbsp;
                        <div class="hover-text"><mat-icon class="customIconSize">info_outlined</mat-icon>
                            <span class="tooltip-text" id="top">Patients will only be able to book online appointments during these periods.</span>
                        </div>
                    </div>

                    <div *ngFor="let docAppDate of appTime | keyvalue;">
                        <mat-accordion class="example-headers-align" multi>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <mat-icon>date_range</mat-icon>
                                    </mat-panel-title>
                                    <mat-panel-description>
                                        {{docAppDate.key}}
                                    </mat-panel-description>
                                </mat-expansion-panel-header>
                                <div *ngFor="let dateId of docAppDate.value | keyvalue">
                                    <div style="float:left;width:100%">
                                        <div style="float:left;width:100%;margin-bottom: 10px;">
                                            <div class="row mb-3" *ngFor="let days of dateId.value | keyvalue">
                                                <div class="col-2">
                                                    {{days.key}}
                                                </div>
                                                <div class="col-10">
                                                    <div class="col-12" *ngFor="let docTime of days.value">
                                                        {{docTime.from_time}} - {{docTime.to_time}} <br />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul class="list-inline m-0">
                                        <li class="list-inline-item">
                                            <button class="btn btn-sm rounded-0" (click)="EditApp(dateId.key)"><i
                                                    class="fa fa-edit"></i>
                                                Edit
                                            </button>
                                        </li>
                                        <li class="list-inline-item">
                                            <button class="btn btn-sm rounded-0" (click)="RemoveApp(dateId.key)"><i
                                                    class="fas fa-trash-alt"></i></button>
                                        </li>
                                    </ul>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion><br>
                    </div>

                    <button type="button" class="btn add_qty btn-sm d-flex align-items-center" *ngIf="hidePeriodApp"
                        (click)="openRow()">
                        <mat-icon>add_outlined</mat-icon> Add period
                    </button>
                    <form [formGroup]="appointmentForm" (submit)="createAppointment()">
                        <div class="col-sm-12" *ngIf="openRowShow">

                            <div class="col-sm-12">
                                <div class="titleNew" *ngIf="!date_id"> New period </div>
                                <div class="titleNew" *ngIf="date_id"> Edit period </div>

                                <div class="description">
                                    One or multiple periods per day are allowed. In case of an overnight period,
                                    please separate the period into two days (e.g. Mon 18:00-23:55 and Tue
                                    00:00-02:00).
                                </div>
                                <div class="row">
                                    <div class="col-sm-3 mt-2">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Start date - End date*</mat-label>
                                            <mat-date-range-input [rangePicker]="picker" formGroupName="appDateRange">
                                                <input matStartDate #dateRangeStart placeholder="Start date"
                                                    formControlName='from_date'>
                                                <input matEndDate #dateRangeEnd placeholder="End date"
                                                    formControlName='to_date'
                                                    (dateChange)="dateRangeChange(dateRangeStart.value, dateRangeEnd.value)">
                                            </mat-date-range-input>
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-date-range-picker #picker></mat-date-range-picker>
                                        </mat-form-field>
                                        <div *ngIf="submitted && f.to_date.errors" class="invalid-feedback">
                                            <div *ngIf="f.to_date.errors.required">Please select date range👆</div>
                                        </div>
                                    </div>
                                </div>
                            </div><br>

                            <div class="col-sm-12" *ngIf="showdays">

                                <!-- -----------------------------👇️ Monday ---------------------------------- -->
                                <div class="row justify-content-left align-items-center" *ngIf="showMonday">
                                    <div class="col-md-2">
                                        <mat-slide-toggle [checked]="true" (change)="slidetoggle($event,day='Monday')">
                                            Monday
                                        </mat-slide-toggle>
                                    </div>

                                    <ng-template [ngIf]="toggleShowhideMonday">
                                        <div class="text-primary pointer-cur" (click)="mondayaddQuantity()">Add
                                        </div>
                                    </ng-template>
                                </div>

                                <!-- st -->
                                <ng-template [ngIf]="toggleShowhideMonday">
                                    <div formArrayName="mondayTime">
                                        <div class="row"
                                            *ngFor="let quantity of mondaybookingDays().controls; let i=index"
                                            [formGroupName]="i" style="margin-left: 168px;">
                                            <div class="mr-2">
                                                <input type="time" class="form-control" placeholder="From Time"
                                                    formControlName="monday_from_time" />
                                            </div>
                                            <div class="mr-2 mt-2">-</div>
                                            <div class="mr-2 mb-4">
                                                <input type="time" class="form-control" placeholder="To Time"
                                                    formControlName="monday_to_time" />
                                            </div>
                                            <div class="text-primary pointer-cur mt-2"
                                                (click)="mondayremoveQuantity(i)">
                                                Remove</div>
                                        </div>
                                    </div>
                                </ng-template>
                                <!---------------------------------👇️ Tuesday ------------------------------------------>
                                <div class="row justify-content-left align-items-center" *ngIf="showTuesday">
                                    <div class="col-md-2">
                                        <mat-slide-toggle [checked]="true" (change)="slidetoggle($event,day='Tuesday')">
                                            Tuesday</mat-slide-toggle>
                                    </div>
                                    <ng-template [ngIf]="toggleShowhideTuesday">
                                        <div class="text-primary pointer-cur" (click)="tuesdayaddQuantity()">Add
                                        </div>
                                    </ng-template>
                                </div>

                                <!-- st -->
                                <ng-template [ngIf]="toggleShowhideTuesday">
                                    <div formArrayName="tuesdayTime" style="display: contents;">
                                        <div class="row"
                                            *ngFor="let quantity of tuesdaybookingDays().controls; let i=index"
                                            [formGroupName]="i" style="margin-left: 168px;">
                                            <div class="mr-2">
                                                <input type="time" class="form-control" placeholder="From Time"
                                                    formControlName="tuesday_from_time" />
                                            </div>
                                            <div class="mr-2 mt-2">-</div>
                                            <div class="mr-2 mb-4">
                                                <input type="time" class="form-control" placeholder="To Time"
                                                    formControlName="tuesday_to_time" />
                                            </div>
                                            <div class="text-primary pointer-cur mt-2"
                                                (click)="tuesdayremoveQuantity(i)">
                                                Remove</div>
                                        </div>
                                    </div>
                                </ng-template>
                                <!---------------------------------👇️ Wednesday ------------------------------------------>
                                <div class="row justify-content-left align-items-center" *ngIf="showWednesday">
                                    <div class="col-md-2">
                                        <mat-slide-toggle [checked]="true"
                                            (change)="slidetoggle($event,day='Wednesday')">Wednesday</mat-slide-toggle>
                                    </div>
                                    <ng-template [ngIf]="toggleShowhideWednesday">
                                        <div class="text-primary pointer-cur" (click)="wednesdayaddQuantity()">Add
                                        </div>
                                    </ng-template>
                                </div>

                                <!-- st -->
                                <ng-template [ngIf]="toggleShowhideWednesday">
                                    <div formArrayName="wednesdayTime" style="display: contents;">
                                        <div class="row"
                                            *ngFor="let quantity of wednesdaybookingDays().controls; let i=index"
                                            [formGroupName]="i" style="margin-left: 168px;">
                                            <div class="mr-2">
                                                <input type="time" class="form-control" placeholder="From Time"
                                                    formControlName="wednesday_from_time" />
                                            </div>
                                            <div class="mr-2 mt-2">-</div>
                                            <div class="mr-2 mb-4">
                                                <input type="time" class="form-control" placeholder="To Time"
                                                    formControlName="wednesday_to_time" />
                                            </div>
                                            <div class="text-primary pointer-cur mt-2"
                                                (click)="wednesdayremoveQuantity(i)">
                                                Remove</div>
                                        </div>
                                    </div>
                                </ng-template>
                                <!---------------------------------👇️ Thursday ------------------------------------------>
                                <div class="row justify-content-left align-items-center" *ngIf="showThursday">
                                    <div class="col-md-2">
                                        <mat-slide-toggle [checked]="true"
                                            (change)="slidetoggle($event,day='Thursday')">Thursday</mat-slide-toggle>
                                    </div>
                                    <ng-template [ngIf]="toggleShowhideThursday">
                                        <div class="text-primary pointer-cur" (click)="thursdayaddQuantity()">Add
                                        </div>
                                    </ng-template>
                                </div>

                                <!-- st -->
                                <ng-template [ngIf]="toggleShowhideThursday">
                                    <div formArrayName="thursdayTime" style="display: contents;">
                                        <div class="row"
                                            *ngFor="let quantity of thursdaybookingDays().controls; let i=index"
                                            [formGroupName]="i" style="margin-left: 168px;">
                                            <div class="mr-2">
                                                <input type="time" class="form-control" placeholder="From Time"
                                                    formControlName="thursday_from_time" />
                                            </div>
                                            <div class="mr-2 mt-2">-</div>
                                            <div class="mr-2 mb-4">
                                                <input type="time" class="form-control" placeholder="To Time"
                                                    formControlName="thursday_to_time" />
                                            </div>
                                            <div class="text-primary pointer-cur mt-2"
                                                (click)="thursdayremoveQuantity(i)">
                                                Remove</div>
                                        </div>
                                    </div>
                                </ng-template>
                                <!---------------------------------👇️ Friday ------------------------------------------>
                                <div class="row justify-content-left align-items-center" *ngIf="showFriday">
                                    <div class="col-md-2">
                                        <mat-slide-toggle [checked]="true" (change)="slidetoggle($event,day='Friday')">
                                            Friday</mat-slide-toggle>
                                    </div>
                                    <ng-template [ngIf]="toggleShowhideFriday">
                                        <div class="text-primary pointer-cur" (click)="fridayaddQuantity()">Add
                                        </div>
                                    </ng-template>
                                </div>

                                <!-- st -->
                                <ng-template [ngIf]="toggleShowhideFriday">
                                    <div formArrayName="fridayTime" style="display: contents;">
                                        <div class="row"
                                            *ngFor="let quantity of fridaybookingDays().controls; let i=index"
                                            [formGroupName]="i" style="margin-left: 168px;">
                                            <div class="mr-2">
                                                <input type="time" class="form-control" placeholder="From Time"
                                                    formControlName="friday_from_time" />
                                            </div>
                                            <div class="mr-2 mt-2">-</div>
                                            <div class="mr-2 mb-4">
                                                <input type="time" class="form-control" placeholder="To Time"
                                                    formControlName="friday_to_time" />
                                            </div>
                                            <div class="text-primary pointer-cur mt-2"
                                                (click)="fridayremoveQuantity(i)">
                                                Remove</div>
                                        </div>
                                    </div>
                                </ng-template>
                                <!---------------------------------👇️ Saturday ------------------------------------------>
                                <div class="row justify-content-left align-items-center" *ngIf="showSaturday">
                                    <div class="col-md-2">
                                        <mat-slide-toggle [checked]="true"
                                            (change)="slidetoggle($event,day='Saturday')">Saturday</mat-slide-toggle>
                                    </div>
                                    <ng-template [ngIf]="toggleShowhideSaturday">
                                        <div class="text-primary pointer-cur" (click)="saturdayaddQuantity()">Add
                                        </div>
                                    </ng-template>
                                </div>

                                <!-- st -->
                                <ng-template [ngIf]="toggleShowhideSaturday">
                                    <div formArrayName="saturdayTime" style="display: contents;">
                                        <div class="row"
                                            *ngFor="let quantity of saturdaybookingDays().controls; let i=index"
                                            [formGroupName]="i" style="margin-left: 168px;">
                                            <div class="mr-2">
                                                <input type="time" class="form-control" placeholder="From Time"
                                                    formControlName="saturday_from_time" />
                                            </div>
                                            <div class="mr-2 mt-2">-</div>
                                            <div class="mr-2 mb-4">
                                                <input type="time" class="form-control" placeholder="To Time"
                                                    formControlName="saturday_to_time" />
                                            </div>
                                            <div class="text-primary pointer-cur mt-2"
                                                (click)="saturdayremoveQuantity(i)">
                                                Remove</div>
                                        </div>
                                    </div>
                                </ng-template>

                                <!---------------------------------👇️ Sunday------------------------------------------>
                                <div class="row justify-content-left align-items-center" *ngIf="showSunday">
                                    <div class="col-md-2">
                                        <mat-slide-toggle [checked]="true" (change)="slidetoggle($event,day='Sunday')">
                                            Sunday</mat-slide-toggle>
                                    </div>
                                    <ng-template [ngIf]="toggleShowhideSunday">
                                        <div class="text-primary pointer-cur" (click)="sundayaddQuantity()">Add
                                        </div>
                                    </ng-template>
                                </div>

                                <!-- st -->
                                <ng-template [ngIf]="toggleShowhideSunday">
                                    <div formArrayName="sundayTime" style="display: contents;">
                                        <div class="row"
                                            *ngFor="let quantity of sundaybookingDays().controls; let i=index"
                                            [formGroupName]="i" style="margin-left: 168px;">
                                            <div class="mr-2">
                                                <input type="time" class="form-control" placeholder="From Time"
                                                    formControlName="sunday_from_time" />
                                            </div>
                                            <div class="mr-2 mt-2">-</div>
                                            <div class="mr-2 mb-4">
                                                <input type="time" class="form-control" placeholder="To Time"
                                                    formControlName="sunday_to_time" />
                                            </div>
                                            <div class="text-primary pointer-cur mt-2"
                                                (click)="sundayremoveQuantity(i)">
                                                Remove</div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div><br>
                            <td class="td1">
                                <button class="btn add_qty" (click)="hideRow()">
                                    Cancel
                                </button>
                            </td>
                            <td class="td1">
                                <button type="submit" [disabled]="loading" class="btn btn-success"><i *ngIf="loading"
                                        class="fa fa-spin fa-spinner"></i>
                                    Save
                                </button>
                            </td>
                        </div>
                    </form>
                    <hr>
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-11 px-0 d-flex align-items-center mb-3">
                                <label class="form-label">Appointment duration
                                    <div class="hover-text"><mat-icon class="customIconSize">info_outlined</mat-icon>
                                        <span class="tooltip-text" id="top">Patients will only be able to book appointments with defined duration.</span>
                                    </div>
                                    
                                </label>
                            </div>
                            <div class="col-sm-1 px-0 d-flex align-items-center mb-3">
                                <button type="button" class="btn add_qty btn-sm d-flex align-items-center" *ngIf="closeDurationOption"
                                (click)="OpenDurationSection()">
                                &nbsp;<mat-icon>edit_outlined</mat-icon>&nbsp;Edit&nbsp;
                                </button>
                            </div>
                            <p *ngIf="closeDurationOption">{{appointment_duration}}</p>
                       </div>
                    </div>
                    <div class="col-sm-12" *ngIf="openDurationOption">
                        <form [formGroup]="durationForm" (submit)="createDuration()">
                            <mat-radio-group aria-label="Select an option" formControlName="appointment_duration">
                                <mat-radio-button value="5">5 min</mat-radio-button>&nbsp;
                                <mat-radio-button value="10">10 min</mat-radio-button>&nbsp;
                                <mat-radio-button value="15">15 min</mat-radio-button>&nbsp;
                                <mat-radio-button value="20">20 min</mat-radio-button>
                            </mat-radio-group>
                            <td class="td2">
                                <button class="btn add_qty mt-1" (click)="hideDurationOption()">
                                    Cancel
                                </button>
                            </td>
                            <td class="td2">
                                <button type="submit" [disabled]="loadingDuration" class="btn btn-success mt-1"><i *ngIf="loadingDuration"
                                        class="fa fa-spin fa-spinner"></i>
                                    Save
                                </button>
                            </td>
                        </form>
                    </div>
                    <hr>
                    <div class="col-sm-12">
                        <div class="col-sm-12 px-0 d-flex align-items-center mb-3">
                            <label class="form-label mb-0">Out of work days</label>&nbsp;
                            <div class="hover-text"><mat-icon class="customIconSize">info_outlined</mat-icon>
                                <span class="tooltip-text" id="top">These periods will be excluded from your appointments schedule.</span>
                            </div>
                        </div>
                        <p *ngFor="let outWork of outWorkData">
                            {{outWork.from_date*1000|date:'d MMM, yyyy'}} - {{outWork.to_date*1000|date:'d MMM, yyyy'}}
                            <i class="fas fa-pen pointer-cur" (click)="EditOutWork(outWork.id)"></i>
                        </p>

                    </div>
                    <button type="button" class="btn add_qty btn-sm d-flex align-items-center" *ngIf="hideperiodOutWork"
                        (click)="OpenoutOfWork()">
                        <mat-icon>add_outlined</mat-icon> Add period
                    </button>
                    <div class="col-sm-12 position-relative" *ngIf="openOutWork">
                        <form [formGroup]="outOfworkForm" (submit)="createOutofWork()">
                            <div class="col-sm-12">
                                <div class="titleNew" *ngIf="!outWork_date_id"> New period </div>
                                <div class="titleNew" *ngIf="outWork_date_id"> Edit period </div>
                                <div class="row">
                                    <div class="col-sm-3 mt-2">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Start date - End date*</mat-label>
                                            <mat-date-range-input [rangePicker]="picker1"
                                                formGroupName="OutOfWorkDateRange">
                                                <input matStartDate #dateRangeStart1 placeholder="Start date"
                                                    formControlName='from_date1'>
                                                <input matEndDate #dateRangeEnd1 placeholder="End date"
                                                    formControlName='to_date1'
                                                    (dateChange)="OutOfWorkdateRangeChange(dateRangeStart1.value, dateRangeEnd1.value)">
                                            </mat-date-range-input>
                                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                            <mat-date-range-picker #picker1></mat-date-range-picker>
                                        </mat-form-field>
                                        <div *ngIf="submittedOutWork && f1.to_date1.errors" class="invalid-feedback mb-5">
                                            <div *ngIf="f1.to_date1.errors.required">Please select date range👆</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <td class="td2">
                                <button class="btn add_qty" (click)="hideoutOfWork()">
                                    Cancel
                                </button>
                            </td>
                            <td class="td2">
                                <button type="submit" [disabled]="loadingOutWork" class="btn btn-success"><i *ngIf="loadingOutWork"
                                        class="fa fa-spin fa-spinner"></i>
                                    Save
                                </button>
                            </td>
                        </form>
                        <td class="td2" *ngIf="outWork_date_id" style="position: absolute;top: 102px;left: 226px;">
                            <button class="btn add_qty" (click)="RemoveOutOfWork(outWork_date_id)">
                                <span style="color: red;">Delete</span>
                            </button>
                        </td>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>